export const blockIconsNotificationTimeToLeave = (
	<span className='material-symbols-outlined'>time_to_leave</span>
);
